import { createTheme } from '@mui/material/styles';
import themeConfig from '../../../common/config';

/**
 * The site's palette, without the global style overrides.
 *
 * `palette` is picked explicitly rather than spreading the shared config and
 * deleting keys: `components` currently holds only `MuiCssBaseline`, whose
 * overrides target bare `a`/`a:hover` and would restyle the host page, but any
 * future global override added for the SPA would arrive here silently.
 */
const embedTheme = createTheme({
    palette: themeConfig.muiTheme.palette
});

export default embedTheme;
